//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../no/PartDelayedUpdateStatus.js";
import "../no/PartLoadStatus.js";
let d=[[[0,"OpenUnloadedParents",1,0],[0,"SelectionScope",1,0]],[[["n_count"],"GetFailedParts",{R_:{part:"BasePart[]"}},0,0],[["part","load_status","delayed_update_status"],"GetLoadInterpartDataStatus",{},1,0]],[]];
SPLM.Assemblies.LoadInterpartDataBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.LoadInterpartDataBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.LoadInterpartDataBuilder.SelectionScopeType = Object.freeze({
    "AllPartsInDisplayedAssembly" : "AllPartsInDisplayedAssembly", "AllPartsInSession" : "AllPartsInSession"});

SPLM.Assemblies.LoadInterpartDataBuilder.OpenUnloadedParentsType = Object.freeze({
    "None" : "None", "ImmediateLevel" : "ImmediateLevel", "AllLevels" : "AllLevels"});

export default SPLM;